<template>
    <div>
        <div class="tab-editor" v-if="tabs.length === 0">
            <div class="mt-3">
                <a class="btn btn_primary-outline" @click="addTab">+ Add Tab</a>
            </div>
        </div>

        <div v-else>
            <draggable v-model="tabs" @end="onDragEnd" class="tabs" style="display: block">
                <div class="tabs__item-row" v-for="(tab, index) in tabs" :key="index">
                    <div class="tabs__item-header">
                        <strong>Tab {{ index + 1 }}</strong>
                        <button type="button" class="tabs__delete" @click="deleteTab(index)">
                            ✕
                        </button>
                    </div>

                    <div class="tabs__item-fields">
                        <input
                            v-model="tab.title"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Title"
                            @input="emitTabs"
                        />
                        <input
                            v-model="tab.content"
                            type="text"
                            class="form-control"
                            placeholder="Content"
                            @input="emitTabs"
                        />
                    </div>
                </div>
            </draggable>

            <div class="add-link mt-3">
                <a href="javascript:void(0)" @click="addTab">+ Add Tab</a>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    name: 'TabListWithTitles',
    components: { draggable },
    props: {
        propsValue: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tabs: []
        }
    },
    methods: {
        addTab() {
            this.tabs.push({
                title: '',
                content: ''
            })
            this.emitTabs()
        },
        deleteTab(index) {
            this.tabs.splice(index, 1)
            this.emitTabs()
        },
        onDragEnd() {
            this.emitTabs()
        },
        emitTabs() {
            this.$emit('update-content', this.tabs)
        }
    },
    mounted() {
        this.tabs = [...this.propsValue]
    }
}
</script>

<style scoped>
.tabs__item-row {
    border: 1px dashed #ccc;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 10px;
}

.tabs__item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tabs__item-fields {
    margin-top: 1rem;
}

.tabs__delete {
    background: none;
    border: none;
    color: #c00;
    cursor: pointer;
    font-size: 16px;
}
</style>
